// Pixel-art sprites of kids playing each Mohalla game (served from /public).
const slug = (name) =>
  (name || "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");

const KNOWN = new Set([
  "aankh-micholi", "baraf-paani", "chain-chain", "chhupan-chhupai", "langdi",
  "lattoo", "oonch-neench", "pakdam-pakdai", "skipping", "stapu", "vish-amrit",
  "gilli-danda", "gitte", "kabaddi", "kho-kho", "kanche", "lagori",
  "patangbaazi", "rassa-kashi", "rolling-tyre", "rumal-jhapatta",
]);

export const getMohallaSprite = (name) => {
  const s = slug(name);
  return KNOWN.has(s) ? `/sprites/mohalla/${s}.png` : null;
};

// Short in-world invite line per game (falls back to a generic one).
export const getInviteLine = (name) => {
  const s = slug(name);
  return {
    "lattoo": "Dekh mera bhawra!",
    "kanche": "Nishaana laga!",
    "gilli-danda": "Gilli uda de!",
    "skipping": "Ek do teen…",
    "stapu": "Langda kaun?",
    "patangbaazi": "Kai po che!",
    "rolling-tyre": "Peeche peeche!",
    "rumal-jhapatta": "Rumal jhapat!",
    "lagori": "Saat pathhar!",
    "kabaddi": "Kabaddi kabaddi!",
    "kho-kho": "Kho de!",
    "pakdam-pakdai": "Pakad ke dikha!",
    "chhupan-chhupai": "Aa gaya!",
    "aankh-micholi": "Aankh band kar!",
    "baraf-paani": "Baraf!",
    "vish-amrit": "Amrit de!",
    "langdi": "Ek tang pe!",
    "chain-chain": "Chain banao!",
    "oonch-neench": "Oonch ya neench?",
    "gitte": "Gitte utha!",
    "rassa-kashi": "Zor lagao!",
  }[s] || "Arre, khelega?";
};
